module.exports = __webpack_public_path__ + "static/media/antes10mg.6c1006d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/img-on-alambrico/antes10mg.png
// module id = 98
// module chunks = 0